import { Components, Theme } from '@mui/material/styles';

export const dialogTheme: Components<Theme>['MuiDialog'] = {
  styleOverrides: {
    paper: ({ theme }) => ({
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.customShadows.dialog,
    }),
  },
};
